import { createEvent } from "effector";
import { SessionContext } from "@type/session/session.types";

export const sessionContextEvent = createEvent<SessionContext | undefined>();

export const setOrigin = createEvent<string | undefined>("SET_ORIGIN");
